import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const OGPLogo = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/ogbbluestacked.png" style={style} />
}
